<template>
  <div v-if="model.$value || model.$schema.fieldRequired" class="mt-2">
    {{ title }}
    <span v-if="showOptionalInfo && !model.$schema.fieldRequired">(opcjonalnie):</span>

    <b>
      &nbsp;{{ model.$value }} &nbsp;<span v-if="model.$error" class="error--text">{{ model.$error }}</span>
    </b>
  </div>
</template>

<script>
// @vuese
// Wyświetlnie wartości z modelu
// @group Forms
export default {
  props: {
    model: { type: Object, required: true },
    showOptionalInfo: { type: Boolean, default: true }
  },
  computed: {
    title() {
      if (!this.model.$schema.title) {
        return this.model.$key;
      }
      const title = this.model.$schema.title.replace(/ \*$/i, '');
      if (this.model.$schema.fieldRequired || !this.showOptionalInfo) {
        return title + ':';
      }
      return title;
    }
  }
};
</script>
